import { css, CSSResult } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cscVariantFilter = {
  labelSelectedOptionColor: css`var(--csc-variant-filter-label-selected-option-color, ${csColorText.muted})`,
  labelSelectedOptionFontWeight: css`var(--csc-variant-filter-label-selected-option-font-weight, 400)`,
}

export const style: CSSResult = css`
  cse-alert {
    margin-bottom: ${csSpacing.spacing06}
  }

  .skeleton-loading {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
    width: 100%;
  }

  .skeleton-field {
    display: flex;
    flex-direction: column;
    row-gap: ${csSpacing.spacing02};
  }

  .skeleton-group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${csSpacing.spacing05};
  }

  .skeleton-loading cse-skeleton {
    --cse-skeleton-min-height: 0;
  }

  .skeleton-circle {
    --cse-skeleton-border-radius: 50%;
  }

  .skeleton-square,
  .skeleton-box {
    --cse-skeleton-border-radius: ${csBorder.radiusMinimal};
  }
`

export const selectedOptionLabelStyle: CSSResult = css`
  .selected-option {
    color: ${cscVariantFilter.labelSelectedOptionColor};
    font-weight: ${cscVariantFilter.labelSelectedOptionFontWeight};
  }
`
